import $http from '@vue-util/http';

/* eslint-disable no-unused-vars*/
export const useProfileStore = defineStore('profile', {
  state: () => ({
    profile: {
      firstName: '',
      lastName: '',
      gender: '',
      dob: '',
      email: '',
      shippingAddress: [],
      isAutoReplenishmentHistory: null,
      ogSignature: '',
      accountVerified: false,
    },
    errorNotification: {
      type: '',
      message: '',
    },
  }),
  actions: {
    setFirstName(firstName) {
      this.profile.firstName = firstName;
    },
    setShippingAddress(shippingAddress) {
      const billingAddress =
        shippingAddress === undefined
          ? []
          : shippingAddress.map((address) => {
              address.line1 = address.addressLine1; // Assign new key
              address.line2 = address.addressLine2 || ''; // Assign new key
              return address;
            });
      this.profile.shippingAddress = billingAddress;
    },
    setUserProfile(userProfile) {
      this.profile.lastName = userProfile.userProfileDetails.lastName;
      this.profile.gender = userProfile.userProfileDetails.gender;
      this.profile.dob = userProfile.userProfileDetails.dob;
      this.profile.email = userProfile.userProfileDetails.email === undefined ? this.profile.email : userProfile.userProfileDetails.email;
      this.profile.isAutoReplenishmentHistory = userProfile.userProfileDetails.isAutoReplenishmentHistory;
      this.profile.ogSignature = userProfile.userProfileDetails.ogSignature;
      this.profile.accountVerified = userProfile.userProfileDetails.accountVerified;
    },
    setErrorNotification(errorNotification) {
      this.errorNotification.type = errorNotification.userProfileResponse.status;
      this.errorNotification.message = errorNotification.userProfileResponse.errors.error[0].message;
    },
    resetErrorNotification() {
      this.errorNotification = { type: '', message: '' };
    },
    async fetchUserProfile(userId) {
      try {
        const response = await $http.post(`/account-xapi/api/userprofile/user/${userId}?_=${Date.now()}`);
        this.setUserProfile(response.data);
      } catch (error) {
        const errorMessage = {
          userProfileResponse: {
            status: 'Failed',
            errors: {
              error: [
                {
                  message: "We're sorry, but we cannot display your information at this time.",
                },
              ],
            },
          },
        };
        this.setErrorNotification(errorMessage);
      }
    },
    updateUserProfile({ userNewProfile, userId }) {
      return new Promise((resolve, reject) => {
        const url = `/account-xapi/api/userprofile/user/${userId}?updateProfileType=ALL`;
        $http
          .put(url, userNewProfile)
          .then((response) => {
            if (response.data.userProfileResponse.status === 'Success') {
              this.setFirstName(userNewProfile.userProfileDetails.firstName);
              resolve(response);
            } else {
              this.setErrorNotification(response.data);
              reject(response);
            }
          })
          .catch(() => {
            // error
          });
      });
    },
  },
});
